import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';

import { Carousel } from '../../../internal/Carousel/Carousel';
import { CarouselItem } from '../../../internal/Carousel/CarouselItem';
import type { CategoryCarouselProps } from '../types';
import { CategoryCard } from './CategoryCard';
import { useGridColumnGap } from 'client-ribbons-design-system/hooks/useGridColumnGap';

export const CategoryCarousel = ({
  categories,
  lazyImages,
  onCategoryClick,
  onNavigation,
  onVisible = () => {},
  title,
}: CategoryCarouselProps) => {
  const columnGap = useGridColumnGap();
  const observedElementRef = useImpressionRef<HTMLDivElement>(() => onVisible());
  const categoriesLength = categories.length;

  return (
    <div ref={observedElementRef}>
      <Carousel
        columnGap={columnGap}
        onNavigateLeft={({ swiped }) => onNavigation?.(swiped, 'prev')}
        onNavigateRight={({ swiped }) => onNavigation?.(swiped, 'next')}
        title={title}
      >
        {categories.map((category, index) => {
          return (
            <CarouselItem
              ariaLabel={`slide ${index + 1} of ${categoriesLength}`}
              key={category.categoryHref}
            >
              <CategoryCard
                lazyImages={lazyImages}
                {...category}
                onLinkClick={(e) => onCategoryClick?.(e, { index })}
              />
            </CarouselItem>
          );
        })}
      </Carousel>
    </div>
  );
};
